/**
 * Copy past from @slash getCookie util
 * @param name - cookie name
 * @returns cookie value
 */
const get = name => {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(name + '=');

    if (c_start !== -1) {
      c_start = c_start + name.length + 1;
      let c_end = document.cookie.indexOf(';', c_start);

      if (c_end === -1) {
        c_end = document.cookie.length;
      }

      return unescape(document.cookie.substring(c_start, c_end));
    }
  }

  return '';
};

const set = (name, value, domain, expiryDays = 90) => {
  const date = new Date();
  date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  const expirationDate = date.toUTCString();
  const cookieConfig = `domain=${domain};path=/;expires=${expirationDate};secure`;
  document.cookie = `${name}=${value};${cookieConfig}`;
};

export default {
  get,
  set
};
//# sourceMappingURL=index.js.map